//////////////////////////////////////////////////////////////////////////////////////   IMPORT
///////////////////////////////////////////////////////////   REACT
import React from 'react';
///////////////////////////////////////////////////////////   LIBS
import Table from 'react-bootstrap/Table';
///////////////////////////////////////////////////////////   SCSS
import './tv-show-program-panel.styles.scss';
//////////////////////////////////////////////////////////////////////////////////////    CLASS SETUP
class TvShowProgramPanel extends React.Component<any, { [key: string]: any }> {
  constructor(props: any) {
    super(props);
    this.state = {
      mainVideo: this.props.mainVideo
    };
  }
  ///////////////////////////////////////////////////////////   LIFECYCLE METHODS
  componentDidUpdate(prevProps: any) {
    if (this.props.mainVideo !== prevProps.mainVideo) {
      this.setState({ mainVideo: this.props.mainVideo });
    }
  }
  ///////////////////////////////////////////////////////////   RENDER
  render() {
    let { mainVideo } = this.state;
    return (
      <Table className='table-styled'>
        <tbody>
          {mainVideo.tvShowProgram
            ? mainVideo.tvShowProgram.map((value: any, index: number) => {
                if (value.data && value.show && value.id !== 'url' && value.id !== 'playlistButtonTitle' && value.id !== 'thumbnailUrl') {
                  return (
                    <tr key={'infoLine_' + index}>
                      <td className='table-cell-data'>{value.label}</td>
                      <td>{value.data}</td>
                    </tr>
                  );
                } else {
                  return null;
                }
              })
            : null}
        </tbody>
      </Table>
    );
  }
}
export default TvShowProgramPanel;
